<template>
  <svg
    viewBox="0 0 24 25"
    stroke="currentColor"
    :class="customStyle"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_147_7037)">
      <path
        d="M9.67412 23.3963C7.68849 22.9768 5.85334 22.0279 4.36312 20.6502C2.87289 19.2725 1.78309 17.5174 1.20919 15.5707C0.635282 13.6241 0.598649 11.5585 1.10317 9.59269C1.60769 7.62693 2.63457 5.83425 4.07501 4.4046C5.51545 2.97495 7.3158 1.96158 9.2853 1.47185C11.2548 0.982128 13.3201 1.03429 15.2624 1.62281C17.2046 2.21133 18.9515 3.3143 20.318 4.81484C21.6844 6.31539 22.6195 8.15762 23.0241 10.1463"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M5.02417 21.1964L6.02417 16.1464H7.10417C7.33225 16.1471 7.55742 16.0952 7.76211 15.9946C7.9668 15.894 8.14547 15.7474 8.28417 15.5664C8.42703 15.3895 8.52598 15.1813 8.57291 14.9588C8.61984 14.7363 8.61342 14.5059 8.55417 14.2864L7.80417 11.2864C7.72557 10.9611 7.5398 10.6718 7.27677 10.465C7.01374 10.2582 6.68876 10.146 6.35417 10.1464H1.02417"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.0241 5.64636H16.9441C16.6095 5.64598 16.2845 5.75823 16.0215 5.96502C15.7585 6.17182 15.5727 6.46113 15.4941 6.78636L15.2141 7.88636"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.7198 16.8793C15.7198 17.2771 15.8779 17.6586 16.1592 17.9399C16.4405 18.2212 16.822 18.3793 17.2198 18.3793C17.6177 18.3793 17.9992 18.2212 18.2805 17.9399C18.5618 17.6586 18.7198 17.2771 18.7198 16.8793C18.7198 16.4814 18.5618 16.0999 18.2805 15.8186C17.9992 15.5373 17.6177 15.3793 17.2198 15.3793C16.822 15.3793 16.4405 15.5373 16.1592 15.8186C15.8779 16.0999 15.7198 16.4814 15.7198 16.8793Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.4898 11.0793L18.9698 12.5293C19.0442 12.7686 19.2057 12.9713 19.4223 13.0972C19.639 13.2232 19.8951 13.2631 20.1398 13.2093L21.6098 12.8693C21.8894 12.805 22.1823 12.8322 22.4453 12.9468C22.7083 13.0614 22.9275 13.2574 23.0708 13.5059C23.2141 13.7544 23.2739 14.0424 23.2413 14.3274C23.2087 14.6124 23.0855 14.8795 22.8898 15.0893L21.8898 16.1993C21.7183 16.3842 21.6231 16.6271 21.6231 16.8793C21.6231 17.1315 21.7183 17.3743 21.8898 17.5593L22.8898 18.6693C23.0855 18.879 23.2087 19.1461 23.2413 19.4311C23.2739 19.7161 23.2141 20.0041 23.0708 20.2526C22.9275 20.5012 22.7083 20.6971 22.4453 20.8117C22.1823 20.9263 21.8894 20.9535 21.6098 20.8893L20.1398 20.5493C19.8951 20.4954 19.639 20.5354 19.4223 20.6613C19.2057 20.7872 19.0442 20.9899 18.9698 21.2293L18.5198 22.6793C18.4415 22.9557 18.2751 23.1991 18.0459 23.3724C17.8167 23.5456 17.5372 23.6394 17.2498 23.6394C16.9625 23.6394 16.683 23.5456 16.4538 23.3724C16.2246 23.1991 16.0582 22.9557 15.9798 22.6793L15.5298 21.2293C15.4555 20.9899 15.294 20.7872 15.0773 20.6613C14.8607 20.5354 14.6046 20.4954 14.3598 20.5493L12.8898 20.8893C12.6102 20.9535 12.3174 20.9263 12.0544 20.8117C11.7914 20.6971 11.5721 20.5012 11.4288 20.2526C11.2855 20.0041 11.2258 19.7161 11.2584 19.4311C11.291 19.1461 11.4141 18.879 11.6098 18.6693L12.6098 17.5593C12.7813 17.3743 12.8766 17.1315 12.8766 16.8793C12.8766 16.6271 12.7813 16.3842 12.6098 16.1993L11.6098 15.0893C11.4141 14.8795 11.291 14.6124 11.2584 14.3274C11.2258 14.0424 11.2855 13.7544 11.4288 13.5059C11.5721 13.2574 11.7914 13.0614 12.0544 12.9468C12.3174 12.8322 12.6102 12.805 12.8898 12.8693L14.3598 13.2093C14.6046 13.2631 14.8607 13.2232 15.0773 13.0972C15.294 12.9713 15.4555 12.7686 15.5298 12.5293L15.9698 11.0793C16.0537 10.8107 16.2212 10.576 16.4478 10.4093C16.6745 10.2426 16.9485 10.1527 17.2298 10.1527C17.5112 10.1527 17.7852 10.2426 18.0118 10.4093C18.2385 10.576 18.406 10.8107 18.4898 11.0793Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_147_7037">
        <rect
          width="24"
          height="24"
          fill="currentColor"
          transform="translate(0 0.389404)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'EarthSettingIcon',
  props: {
    customStyle: {
      type: String,
      default: 'w-5 h-5',
    },
  },
}
</script>
